import { NodeViewContent } from '@tiptap/react';
import { FC } from 'react';
import { ExtractInfoSectionComponentProps } from './types';

export const ExtractInfoGeneratedSection: FC<
  ExtractInfoSectionComponentProps
> = () => {
  return <NodeViewContent />;
};
